import * as THREE from 'three';
import "./style.css";
import DeviceOrientationControls from './DeviceOrientationControls.js'; 
			let camera, scene, renderer, controls;

			let isUserInteracting = false,
				lon = 0, lat = 0,
				phi = 0, theta = 0,
				onPointerDownPointerX = 0,
				onPointerDownPointerY = 0,
				onPointerDownLon = 0,
				onPointerDownLat = 0;

			const distance = 50;

			init();
			animate();

			function init() {

        const usercam = document.querySelector("#user_camera");
        var constraints = {audio: false, video: true};

        navigator.mediaDevices.getUserMedia(constraints)
        .then(function(stream) {
          usercam.srcObject = stream;
          usercam.onloadedmetadata = function(e) {
            usercam.play();
          }
       
          
        })
        .catch(function(err) {
          /* handle the error */
        });

				const container = document.getElementById( 'container' );

				camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 1, 1100 );

				scene = new THREE.Scene();

				const geometry = new THREE.SphereGeometry( 500, 60, 40 );
				// invert the geometry on the x-axis so that all of the faces point inward
				geometry.scale( - 1, 1, 1 );

				const video = document.getElementById( 'video360' );
        video.src = "static/video360.webm";
        video.onloadedmetadata = function(e) {
          video.play();
        }        
				

				const texture = new THREE.VideoTexture( video );
        texture.format = THREE.RGBAFormat;
				const material = new THREE.MeshBasicMaterial( { map: texture } );

				const mesh = new THREE.Mesh( geometry, material );
				scene.add( mesh );

				renderer = new THREE.WebGLRenderer({alpha:true});
				renderer.setPixelRatio( window.devicePixelRatio );
				renderer.setSize( window.innerWidth, window.innerHeight );
				container.appendChild( renderer.domElement );

				document.addEventListener( 'pointerdown', onPointerDown );
				document.addEventListener( 'pointermove', onPointerMove );
				document.addEventListener( 'pointerup', onPointerUp );

				//

				window.addEventListener( 'resize', onWindowResize );

        controls = new DeviceOrientationControls(camera);

			}

			function onWindowResize() {

				camera.aspect = window.innerWidth / window.innerHeight;
				camera.updateProjectionMatrix();

				renderer.setSize( window.innerWidth, window.innerHeight );

			}

			function onPointerDown( event ) {

				isUserInteracting = true;

				onPointerDownPointerX = event.clientX;
				onPointerDownPointerY = event.clientY;

				onPointerDownLon = lon;
				onPointerDownLat = lat;

			}

			function onPointerMove( event ) {

				if ( isUserInteracting === true ) {

					lon = ( onPointerDownPointerX - event.clientX ) * 0.1 + onPointerDownLon;
					lat = ( onPointerDownPointerY - event.clientY ) * 0.1 + onPointerDownLat;

				}

			}

			function onPointerUp() {

				isUserInteracting = false;

			}

			function animate() {

				requestAnimationFrame( animate );
				//update();
        controls.update();
				renderer.render( scene, camera );

			}

			function update() {

				lat = Math.max( - 85, Math.min( 85, lat ) );
				phi = THREE.MathUtils.degToRad( 90 - lat );
				theta = THREE.MathUtils.degToRad( lon );

				camera.position.x = distance * Math.sin( phi ) * Math.cos( theta );
				camera.position.y = distance * Math.cos( phi );
				camera.position.z = distance * Math.sin( phi ) * Math.sin( theta );

				camera.lookAt( 0, 0, 0 );
       // controls.update();
				renderer.render( scene, camera );

			}